export default {"src":"/account/preferences/_next/static/media/Mailbox.672356f0.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};